import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import validator from "validator";
import AuthTerm from "../../../components/AuthTerm/authTerm";
import CreatorQuote from "../../../components/CreatorQuote/creatorQuote";
import ErrorMsg from "../../../components/ErrorMsg/errorMsg";
import { loginEmail } from "../../../Utils/SupabaseServices/UserDatabase";
import { supabase } from "../../../config/supabaseClient";
import "./EmailLogin.css";

import track, { TRACKING_TYPES } from "../../../Utils/SupabaseServices/Track";

const EmailLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<any>("");
  const [emailError, setEmailError] = useState<any>("");
  const location = useLocation()
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768);
		};
		window.addEventListener('resize', handleResize);
	}, []);

  useEffect(() => {
    track(location.pathname, TRACKING_TYPES.PAGE, {
      pathname: location.pathname,
      user_id: "",
    });
  }, []);

  async function signInWithEmail(e: any) {
    e.preventDefault();
    // const signInData = await loginEmail(email, password);
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });


    if (error) {
      console.error("Authentication error:", error);
      setError("Invalid login credentials. Please try again.");
      return;
    }

    if (!data) {
      navigate("/404");
      return;
    }

    try {
      // First try to find if user is a team member using creator_id from metadata
      const creatorId = data.user?.user_metadata?.creator_id;
      if (creatorId) {
        // Approach 1: Use creator_id to find the creator
        const { data: creator, error: creatorError } = await supabase
          .from("user")
          .select("*")
          .eq("user_id", creatorId)
          .single();
        if (!creatorError && creator) {
          // Store the creator info and navigate
          localStorage.setItem("loggedIn", creator.username);
          localStorage.setItem("member", JSON.stringify(creator));
          // Dispatch a custom event to notify useAuth
          window.dispatchEvent(new Event('memberLogin'));
          navigate(`/dashboard/${creator.username}`);
          return;
        }
      }

      // Approach 2: Search in team_member arrays if approach 1 failed
      // const { data: creators, error: creatorsError } = await supabase
      //   .rpc('find_team_member', { 
      //     member_email: email,
      //     member_status: 'active'
      //   });


      // if (creatorsError) {
      //   console.error("Team member verification error:", creatorsError);
      //   setError("Error verifying team membership. Please contact support.");
      //   return;
      // }

      // if (creators && creators.length > 0) {
      //   // Store the first creator's info and navigate
      //   const creator = creators[0];
      //   localStorage.setItem("member", JSON.stringify(creator));
      //   navigate(`/dashboard/${creator.username}`);
      // } 
      else {
        // Regular user flow - use their own data
        const { data: userData, error: userError } = await supabase
          .from("user")
          .select("*")
          .eq("email", email)
          .single();
        if (userError || !userData) {
          setError("Error fetching user data. Please try again.");
          return;
        }

        // For regular users, just store username and navigate
        // Don't dispatch userLogin event - let Supabase handle the session
        localStorage.setItem("loggedIn", userData.username);
        navigate(`/dashboard/${userData.username}`);
      }
    } catch (err: any) {
      console.error("Login flow error:", err);
      setError("An unexpected error occurred. Please try again.");
    }
  }
  const validateEmail = (email: any) => {
    if (validator.isEmail(email)) {
      setEmailError("");
      return true;
    } else {
      setEmailError("Enter valid Email!");
    }
  };
  function validateCredentials(e: any) {
    e.preventDefault();
    if (validateEmail(email)) {
      signInWithEmail(e);
    }
  }
  function SubmitButton(props: any) {
    if (email && password) {
      return <button className="submit-btn">{props.name}</button>;
    } else {
      return (
        <button className="submit-btn">
          {props.name}
        </button>
      );
    }
  }

  return (
    <div className="auth-container">
      <div
        className="login-auth"
      >
        <div className="auth-phone-signup-container-flex">

          <div className='navbar_container'>
            <a href="/" className='navbar_logo-link w-nav-brand' aria-label='home'>
              <div className='logo-text'
              >
                <img
                  className='homepage-icon-logo'
                  // src='/assets/output-onlinepngtools-edited.png'
                  // src="/assets/NewLogo-removebg.png"
                  src={isMobile ? "/assets/Logo-White.svg" : "/assets/Wordmark+Logo-White.svg"}
                  alt='search bubble logo'
                />
              </div>
            </a>
            <nav className='navbar_menu w-nav-menu'>
              <div className='navbar_menu-link-wrapper'>

                <a href="/subscribe" className="navbar_link w-nav-link sign-up">sign up for free</a>
              </div>
            </nav>
          </div>

          <div className="auth-form-wrapper">
            <div className="auth-title-div">
              <p className="auth-title-div-p">Welcome back</p>
            </div>

            <form className="input-form" onSubmit={validateCredentials}>
              <div className="input-div email">
                {" "}
                <input
                  type="email"
                  placeholder="Email"
                  onChange={(e: any) => setEmail(e.target.value)}
                  required
                />
              </div>
              {emailError ? <ErrorMsg error={emailError} /> : ""}
              <div className="input-div">
                {" "}
                <input
                  type="password"
                  placeholder="Password"
                  onChange={(e: any) => setPassword(e.target.value)}
                  required
                />
              </div>{" "}
              {error ? <ErrorMsg error={error} /> : ""}
              <SubmitButton name="Sign in" />
            </form>


          </div>
          <AuthTerm />
        </div>
        <CreatorQuote />
      </div>
    </div>

  );
};

export default EmailLogin;